//#region src/fetch-network-errors/fetch-network-errors.ts
const CHROMIUM_FETCH_FAILED_MESSAGE = "Failed to fetch";
const FIREFOX_FETCH_FAILED_MESSAGE = "NetworkError when attempting to fetch resource";
const WEBKIT_FETCH_FAILED_MESSAGE = "Load failed";
const WEBKIT_FETCH_FAILED_MESSAGE_LEGACY = "The Internet connection appears to be offline.";
const CHROMIUM_BODY_STREAM_FAILED_MESSAGE = "network error";
const FIREFOX_BODY_STREAM_FAILED_MESSAGE = "Error in input stream";
const REQUEST_FAILED_MESSAGES = [
	CHROMIUM_FETCH_FAILED_MESSAGE,
	FIREFOX_FETCH_FAILED_MESSAGE,
	WEBKIT_FETCH_FAILED_MESSAGE,
	WEBKIT_FETCH_FAILED_MESSAGE_LEGACY
];
const FETCH_FAILED_MESSAGES = [
	...REQUEST_FAILED_MESSAGES,
	CHROMIUM_BODY_STREAM_FAILED_MESSAGE,
	FIREFOX_BODY_STREAM_FAILED_MESSAGE
];
const isNoResponseError = (error) => error instanceof Error && REQUEST_FAILED_MESSAGES.some((message) => error.message.startsWith(message));
const containsNetworkFailure = (error) => error instanceof Error && FETCH_FAILED_MESSAGES.some((message) => error.message.includes(message));
//#endregion
export { CHROMIUM_BODY_STREAM_FAILED_MESSAGE, CHROMIUM_FETCH_FAILED_MESSAGE, FIREFOX_BODY_STREAM_FAILED_MESSAGE, FIREFOX_FETCH_FAILED_MESSAGE, WEBKIT_FETCH_FAILED_MESSAGE, WEBKIT_FETCH_FAILED_MESSAGE_LEGACY, containsNetworkFailure, isNoResponseError };
